// Máscara para campos do tipo CNPJ
angular.module("avlib").directive("avCnpjMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var formatCnpj = function(value){
				if (value == null || value == ""){
					ctrl.$setValidity("cnpj", true);
					return value;
				}
				// Removendo todos os caracteres não alfa numéricos:
				value = value.replace(/[^a-zA-Z0-9]/g,'');
				
				// Substituindo os caracteres alfa numéricos por letras maiúsculas:
				value = value.toUpperCase();

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do CNPJ:
				if (value.length > 2){
					value = value.substr(0,2) + "." + value.substr(2);

					if (value.length > 6){
						value = value.substr(0,6) + "." + value.substr(6);

						if (value.length > 10){
							value = value.substr(0,10) + "/" + value.substr(10);
							
							if (value.length > 15){
								value = value.substr(0,15) + "-" + value.substr(15);
								
								// Eliminando caracteres em excesso:
								if (value.length > 18){
									value = value.substr(0,18);
								}
							}
						}
					}
				}
				ctrl.$setValidity("cnpj", isValidCnpj(value));
				return value;
			};

			function isValidCnpj(cnpj) {
			    // Remove pontuação and convert to uppercase
			    cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

			    // Verifica tamanho
			    if (cnpj.length !== 14) {
			        return false;
			    }

			    // Rejeita sequências repetidas óbvias
			    if (/^(\w)\1{13}$/.test(cnpj)) {
			        return false;
			    }

			    // Valida os dois dígitos verificadores (Módulo 11)
			    for (let t = 12; t < 14; t++) {
			        let soma = 0;
			        let peso = (t === 12) ? 5 : 6;

			        for (let i = 0; i < t; i++) {
			            const char = cnpj[i];

			            // Converte caractere para valor numérico (ASCII)
			            // Número (0-9): código ASCII - 48
			            // Letra (A-Z): código ASCII - 48
			            const valor = char.charCodeAt(0) - 48;

			            soma += valor * peso;
			            peso = (peso === 2) ? 9 : peso - 1;
			        }

			        const resto = soma % 11;
			        const digitoCalculado = (resto < 2) ? 0 : 11 - resto;

			        if (parseInt(cnpj[t], 10) !== digitoCalculado) {
			            return false;
			        }
			    }

			    return true;
			};
			
			var cnpjParser = function(viewValue){
				var formattedCnpj = formatCnpj(viewValue);
				ctrl.$setViewValue(formattedCnpj);
				ctrl.$render();
				var unmaskedCnpj = formattedCnpj.replace(/[^a-zA-Z0-9]/g,'');
				if (isValidCnpj(unmaskedCnpj)){
					return unmaskedCnpj;
				}
			};

			var cnpjFormatter = function(viewValue){
				if (viewValue){
					var modelValue = (""+viewValue).replace(/[^a-zA-Z0-9]/g,'');
					if (isValidCnpj(modelValue)){
						ctrl.$modelValue = modelValue;
					}
					return formatCnpj(modelValue);
				}
			};

			ctrl.$parsers.push(cnpjParser);
			ctrl.$formatters.push(cnpjFormatter);
		}
	};
});
